<div class="py-2">
  <div class="task-container-inner" [class.isCarryOver]="isCarryOver">
    <div class="flex pb-2 pl-1 pt-1 gap-1">
      <div class="flex-grow-1">
        <div class="font-bold" style="font-size: 16px">
          {{ addressLineDisplay }}
        </div>
      </div>
      <div class="flex-shrink-1 style2023">
        <div *ngIf="isCarryOver">
          <div class="carryOverText"><i class="fa fa-moon-o"></i> Carryover</div>
        </div>
        <div *ngIf="!isCarryOver">
          <div class="white-space-nowrap drop-off-pick-up-label" *ngIf="isPickup">
            Pickup
            {{ taskNumber }}
            <i class="fa fa-arrow-up"></i>
          </div>
          <div class="white-space-nowrap drop-off-pick-up-label" *ngIf="!isPickup">
            Dropoff
            {{ taskNumber }}
            <i class="fa fa-arrow-down"></i>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!isCarryOver" class="pb-2 pl-1 date-and-time">
      <span class="mr-2" *ngIf="dateString.length > 0">
        <i class="fa fa-calendar"></i>
        {{ dateString }}
      </span>
      <span *ngIf="timeString.length > 0">
        <i class="fa fa-clock-o"></i>
        {{ timeString }}
      </span>
    </div>

    <div *ngIf="isCarryOver" class="pb-2 pl-1 date-and-time">
      <span class="mr-2">
        <span class="mr-2 text-blue-900 opacity-70">Arrive: </span>
        <i class="fa fa-calendar"></i>
        {{ formatDateString(arriveHomeEarliest, arriveHomeLatest) }}
      </span>
      <span>
        <i class="fa fa-clock-o"></i>
        {{ formatTimeString(arriveHomeEarliest, arriveHomeLatest) }}
      </span>
    </div>
    <div *ngIf="isCarryOver" class="pb-2 pl-1 date-and-time">
      <span class="mr-2">
        <span class="mr-2 text-blue-900 opacity-70">Leave: </span>
        <i class="fa fa-calendar"></i>
        {{ formatDateString(leaveHomeEarliest, leaveHomeLatest) }}
      </span>
      <span>
        <i class="fa fa-clock-o"></i>
        {{ formatTimeString(leaveHomeEarliest, leaveHomeLatest) }}
      </span>
    </div>

    <div *ngIf="showTaskBadges">
      <span class="tag">{{ plannedTask.taskTypeName }}</span>
      <span class="tag" title="{{ plannedTask.vehicle?.make }} {{ plannedTask.vehicle?.model }}"
        ><i class="la la-car-side"></i> {{ plannedTask.vehicle?.make }}
        {{ plannedTask.vehicle?.model }}</span
      >
      <span *ngIf="plannedTask.vehicle.isElectric" class="tag bolt"
        ><i class="fa fa-bolt"></i> Electric</span
      >
    </div>
  </div>
</div>
